import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";
import endpointsData from "../../json/sampleEndpts.json";

const StaticMapServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {
    let endpt_elem = endpointsData;

    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const data = JSON.stringify(false);
    \nconst xhr = new XMLHttpRequest();
    \nxhr.addEventListener("readystatechange", function () {
      if (this.readyState === this.DONE) {
      }
    });
    \nxhr.open("GET", "https://www.onemap.gov.sg${endpt_elem.sampleRequest}");
    \nxhr.setRequestHeader("Authorization", "**********************");
    \nxhr.send(data);`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>

      <Helmet>
        <title>Static Map | OneMap API</title>
        <meta
          name="description"
          content="Create personalized static maps with the Static Map API. Generate PNG images based on specified parameters, overlay points, polygons, or polylines, and customize map styles, zoom levels, and dimensions. Perfect for developers and geospatial analysts looking to visualize data in Singapore."
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div className="om-planning-section">
              <h1 id="getStaticMap">Static Map</h1>
              <p>
                This API returns a static image of a map based on the defined
                parameters in PNG format which users may overlay multiple
                point(s), polygon(s), or polyline(s) on the map
                <br />
                <br />
                Users can also create personalised static maps via the{" "}
                <a
                  href="https://www.onemap.gov.sg/tools/staticmap/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Static Map Creator
                </a>
              </p>
              <br />
              <h3 className="om-planning-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">400 - Please select a valid map style</p>
                <p className="slate-p">400 - Please enter a valid zoom level</p>
                <p className="slate-p">
                  400 - Please enter a pair of valid width and height(in
                  pixels).
                </p>
                <p className="slate-p">
                  400 - The maximum resolution size is 512 x 512.
                </p>
                <p className="slate-p">
                  400 - Please enter a pair of valid latitude & longitude.
                </p>
              </div>
              <br />

              <div className="om-planning-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className="om-planning-items">
                  <div className="om-planning-item">
                    <div className="label-method">
                      layerchosen
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Choice of available base maps: night, grey, original,
                        default and landlot
                      </p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      latitude
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      longitude
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      postal
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>Either latitude/longitude or postal should be used.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      zoom
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Values: 11- 19. The zoom level of the static image. The
                        lower the value, the more zoomed out the static image.
                      </p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      width
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>Values: 128- 512. The width of the static image.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      height
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>Values: 128- 512. The height of the static image.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      polygons
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Coordinates of polygon(s) to be overlaid on the base
                        map. Polygon(s) and its color are segregated by
                        semicolon. Whereas each polygon is differentiated with a
                        pipe. The start and end must be of the same point but
                        all other points should be unique.
                      </p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      lines
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Coordinates of line(s) to be overlaid on the base map.
                        Line(s), its color, and thickness are segregated by
                        semicolon. Each line is differentiated with a pipe.
                      </p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      points
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Coordinates of point(s) to be overlaid on the base map.
                        Coordinates of individual point are segregated with a
                        comma. Each point is differentiated with a pipe. This is
                        an example of 2 points differentiated with pipe,
                        [1.31955,103.84223,"255,255,178"]|[1.31801,103.84224,"175,50,0"]
                      </p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      color
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Specifies the color of all lines. Color must be in RGB
                        format. EG: 255, 0, 255.
                      </p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      fillColor
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Specifies the fill color of all polygons. Color must be
                        in RGB format. EG: 0, 255, 0.
                      </p>
                    </div>
                  </div>
                  <br />
                  {/* <img src={staticmapImg} alt='staticmapImg' /> */}
                </div>
              </div>
            </div>
            <Endpoint {...endpointreturn("staticMap")} />
            {/* <img src={staticmapImg} alt='staticmapImg' /> */}
            <br />
            <div
              className="d-flex justify-content-between"
              style={{ marginBottom: "20px" }}
            ></div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default StaticMapServices;
